import { roleInstance } from 'Interfaces/roleBasedAccessInterfaces';

interface bdTrackerRolesInterface {
  cardAssigneeChangingDropdown: roleInstance[];
  editOpportunitySaveButton: roleInstance[];
  commentAddButton: roleInstance[];
  nadWaiverSaveButton: roleInstance[];
  siteTransferSaveButton: roleInstance[];
  createNewIterationButton: roleInstance[];
  addNewOpportunityButton: roleInstance[];
  listViewStageStatusAnalyst: roleInstance[];
}

export const bdTrackerAllowedRoles: bdTrackerRolesInterface = {
  cardAssigneeChangingDropdown: [
    { department: 'bd', role: 'basicUser' },
    { department: 'bd', role: 'admin' },
  ],
  editOpportunitySaveButton: [
    { department: 'bd', role: 'basicUser' },
    { department: 'bd', role: 'admin' },
  ],
  commentAddButton: [
    { department: 'bd', role: 'basicUser' },
    { department: 'bd', role: 'admin' },
  ],
  nadWaiverSaveButton: [
    { department: 'bd', role: 'basicUser' },
    { department: 'bd', role: 'admin' },
  ],
  siteTransferSaveButton: [
    { department: 'bd', role: 'basicUser' },
    { department: 'bd', role: 'admin' },
  ],
  createNewIterationButton: [
    { department: 'bd', role: 'basicUser' },
    { department: 'bd', role: 'admin' },
  ],
  addNewOpportunityButton: [
    { department: 'bd', role: 'basicUser' },
    { department: 'bd', role: 'admin' },
  ],
  listViewStageStatusAnalyst: [
    { department: 'bd', role: 'basicUser' },
    { department: 'bd', role: 'admin' },
  ],
};
